import React from 'react'
import {EventsGrid} from '../components/events/EventsGrid'

const Events = () => (
    <section>
        <EventsGrid/>
    </section>
)


export default Events